import { z } from 'zod';
import { InvoiceType, InvoiceStatus, PaymentMethod, SALStatus, ChangeReqStatus } from '../enums.js';
const isoDate = z.string().datetime().or(z.string().regex(/^\d{4}-\d{2}-\d{2}$/));
export const invoiceLineInput = z.object({
    description: z.string().min(1).max(500),
    quantity: z.coerce.number().min(0).default(1),
    unitPrice: z.coerce.number().min(0),
    vatRate: z.coerce.number().min(0).max(100).default(22),
});
export const createInvoiceInput = z.object({
    type: z.nativeEnum(InvoiceType).default(InvoiceType.FATTURA),
    clientId: z.string(),
    projectId: z.string().optional().nullable(),
    issueDate: isoDate.optional().nullable(),
    dueDate: isoDate.optional().nullable(),
    paymentMethod: z.nativeEnum(PaymentMethod).optional().nullable(),
    notes: z.string().max(2000).optional().nullable(),
    lines: z.array(invoiceLineInput).min(1),
    status: z.nativeEnum(InvoiceStatus).default(InvoiceStatus.BOZZA),
});
export const updateInvoiceInput = createInvoiceInput.partial();
export const salPaymentInput = z.object({
    projectId: z.string(),
    milestoneId: z.string().optional().nullable(),
    label: z.string().min(1).max(200),
    amount: z.coerce.number().min(0),
    dueDate: isoDate.optional().nullable(),
    status: z.nativeEnum(SALStatus).default(SALStatus.PREVISTA),
});
export const changeRequestInput = z.object({
    projectId: z.string(),
    label: z.string().min(1).max(200),
    amount: z.coerce.number().min(0),
    date: isoDate.optional().nullable(),
    status: z.nativeEnum(ChangeReqStatus).default(ChangeReqStatus.IN_VALUTAZIONE),
    notes: z.string().max(2000).optional().nullable(),
});
//# sourceMappingURL=invoice.js.map